import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sequence-selection"
export default class extends Controller {
  static targets = ["checkbox", "analyzeButton", "analyzeCount"]

  connect() {
    this.updateButton()
  }

  updateSelection() {
    this.updateButton()
  }

  updateButton() {
    const selectedIds = this.getSelectedIds()
    const count = selectedIds.length

    if (count > 0) {
      this.analyzeButtonTarget.style.display = "inline-flex"
      this.analyzeCountTarget.textContent = `Analyze ${count} sequence${count > 1 ? 's' : ''}`
    } else {
      this.analyzeButtonTarget.style.display = "none"
    }
  }

  analyze() {
    const selectedIds = this.getSelectedIds()

    if (selectedIds.length === 0) {
      alert("Please select at least one sequence")
      return
    }

    // Get the virus type code from the current URL
    const pathParts = window.location.pathname.split('/')
    const virusTypeCode = pathParts[2] // /database/:virus_type_code/sequences

    // Build the URL with sequence_ids as query parameters
    const params = new URLSearchParams()
    selectedIds.forEach(id => params.append('sequence_ids[]', id))

    const url = `/database/${virusTypeCode}/phylogenetic_runs/new?${params.toString()}`
    window.location.href = url
  }

  getSelectedIds() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.dataset.sequenceId)
  }
}
